import type { InviteProjectByEmailData } from '../types';
import type { ShareRole } from '@eureka/services/src/types/share';

export interface SharedUserListParams {
  work_project_id: string;
  page: number;
  limit: number;
}

export interface SharedUser {
  share_id: string;
  user_email: string;
  share_type: ShareRole;
  valid: boolean;
}

export interface SharedUserListResponse {
  page: number;
  limit: number;
  total: number;
  result: SharedUser[];
}

export interface RemoveSharedUserParams {
  work_project_id: string;
  share_id: string;
}

export interface ProjectShareApi {
  shareByEmail(params: InviteProjectByEmailData): Promise<void>;
  getSharedUserList(params: SharedUserListParams): Promise<SharedUserListResponse>;
  removeSharedUser(params: RemoveSharedUserParams): Promise<void>;
}

export const ProjectShareApi = Symbol('ProjectShareApi');
